<template>
  <div class="news-detail">
    <div class="header-box">
      <layoutHeader :default-bg="'rgba(0,0,0,0.4)'"/>
    </div>
    <div class="banner">
      <img src="https://ssv-website.oss-cn-shenzhen.aliyuncs.com/mainland/image/1661423697043232400.png" alt="">
    </div>
    <div class="content">
      <div class="main-container">

        <div class="header">
          <div class="title">{{detail.headline}}</div>
          <div class="date">{{detail.createTime}}</div>
        </div>
        <div class="info" v-html="detail.newsContent"></div>
      </div>
      <div class="bottom">
        <div class="pre" v-if="detail.lastId">
          <router-link :to="'/news/detail?id='+detail.lastId">上一篇</router-link>
        </div>
        <div class="next" v-if="detail.nextId">
          <router-link :to="'/news/detail?id='+detail.nextId">下一篇</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import layoutHeader from '@/components/layout/header'
import Model from '@/model/news'

export default {
  components: {
    layoutHeader,
  },
  name: 'layout',
  data() {
    return {
      activeName: 'second',
      detail: {}
    }
  },
  watch:{
    '$route'(val, from) {//监听到路由（参数）改变
       this.getDetail()
    }
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
    async getDetail() {
      const res = await Model.getDetail(this.$route.query.id)
      res.data.createTime = this.timestampToDate(res.data.createTime)
      this.detail = res.data
    },
    timestampToDate(timestamp) {
      const date = new Date(timestamp);
      return  date.getFullYear() + '-' + (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-' + date.getDate() + ' '
    }
  },
  async created() {
    await this.getDetail()
  },
  mounted() {
  },
}
</script>

<style lang="scss" scoped>


.news-detail {
  display: flex;
  flex-direction: column;
  align-items: center;

  .header-box {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 100;
  }

  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 40px;

    .header {
      width: 100%;
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      padding: 60px 0;

      .title {
        font-size: 49px;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.8);
        text-align: left;
        line-height: 60px;
      }

      .date {
        font-size: 16px;
        color: rgba(0, 0, 0, 0.4);
        width: 300px;
      }
    }

    .info {
      width: 100%;
      text-align: left;
      font-size: 16px;
      line-height: 30px;
    }

  }

  .bottom {
    display: flex;
    justify-content: center;
    padding: 90px;

    div {
      height: 42px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 20px;
      margin: 0 20px;
      font-size: 16px;
      border-radius: 2px;
      color: rgba(0, 0, 0, 0.6);
      border: 1px solid rgba(0, 0, 0, 0.3);

    }
  }

  .banner {
    width: 100%;

    img {
      width: 100%;
      height: auto;
    }
  }

}
</style>
